import { useQueryParams } from 'hooks/useQueryParams'
import { FormModalContainer } from '../WorkspaceMembershipProfileForm/FormModalContainer'
import { UpdatePaymentMethodModal } from 'components/UpdatePaymentMethodModal/UpdatePaymentMethodModal'
import { useHistory, useLocation } from 'react-router-dom'
import { InviteTeamModal } from 'components/Growth/InviteTeamModal/InviteTeamModal'
import { UpgradePlanModal } from 'components/Paywall/UpgradePlanModal/UpgradePlanModal'
import { Wizards } from 'components/Wizards/Wizards'
import { useModals } from 'almanac-ui/Modal'
import { useCallback, useEffect, useMemo } from 'react'
import { useRootStore } from 'stores/RootStore'
import { observer } from 'mobx-react-lite'
import { MultiStepInstagramPlanningWizard } from 'components/Wizards/InstagramPlanning/MultiStepInstagramPlanningWizard'
import { IntegrationsModal } from 'components/IntegrationsModal/IntegrationsModal'
import { AnnualUpgrade } from 'components/AnnualUpgrade/AnnualUpgrade'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { WizardsDrawer } from 'components/Wizards/WizardsDrawer/WizardsDrawer'

export const URLModal = observer(() => {
  const { modal } = useQueryParams()
  const history = useHistory()
  const { pathname, search } = useLocation()
  const rootStore = useRootStore()
  const featureFlags = rootStore.featureFlags
  const { isMobile } = useResponsiveDesign()

  const queryParams = useMemo(() => {
    const params = new URLSearchParams(search)
    params.delete('modal')
    return params
  }, [search])

  const { openModal } = useModals()

  const handleClose = useCallback(() => {
    return history.push({ pathname, search: queryParams.toString() })
  }, [history, pathname, queryParams])

  // Ensure feature flags are loaded before opening the modal
  useEffect(() => {
    if (!featureFlags.ready) return

    if (modal === 'create-new') {
      if (isMobile) {
        rootStore.drawersStore.openDrawer(WizardsDrawer)
      } else {
        openModal(Wizards)
      }
      handleClose()
    }
  }, [modal, handleClose, openModal, featureFlags.ready, isMobile, rootStore.drawersStore])

  switch (modal) {
    case 'invite-team-member':
      return <InviteTeamModal />
    case 'edit-profile':
      return <FormModalContainer onClose={handleClose} />
    case 'update-payment-method':
      return <UpdatePaymentMethodModal onClose={handleClose} />
    case 'upgrade-plan':
      // Setting frequency to a year because this is being used for our Black Friday Annual Discount.
      return <UpgradePlanModal initialBillingFrequency="year" onClose={handleClose} showSuccessModal={false} />
    case 'annual-upgrade':
      return <AnnualUpgrade handleClose={handleClose} />
    case 'ig-planning':
      return <MultiStepInstagramPlanningWizard onClose={handleClose} />
    case 'integrations':
      return <IntegrationsModal />
    default:
      return null
  }
})
